import React from "react"
const Checkbox = React.memo(({ handleCheck, title, isChecked, value, name }) => {
  return (
    <div className="row_check form-check-f justify-content-start" style={{ minWidth: "15%", }}>
      <label className="custom-checkbox checkbox">
        <input
          type="checkbox"
          name="select-all"
          id={title}
          checked={isChecked}
          onChange={handleCheck}
          value={value}
        />

        <span className="checkmark"></span>

      </label>
      <label
        className="form-check-label-f"
        htmlFor={title}>
        {title}
      </label>
    </div>
  )
})

export default Checkbox
